import * as R from 'ramda'
import * as ReactRouter from 'react-router-dom'
import * as React from 'react'
import * as ReactRedux from 'react-redux'

import * as Common from '@rushplay/common'
import * as Herz from '@rushplay/herz'

import * as Promotions from './promotions'
import * as Theming from './theming'
import { Card } from './card'
import { Heading } from './heading'
import { HtmlContent } from './html-content'
import { NotFound } from './not-found'
import { useServerConfiguration } from './server-configuration'

function getPromotionDate(date, locale) {
  return new Date(date).toLocaleDateString(locale.slug, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  })
}

export function PromotionTermsAndConditionsPage() {
  const { key } = ReactRouter.useParams()
  const { locale } = useServerConfiguration()
  const promotion = ReactRedux.useSelector(state =>
    Promotions.getPromotionByKey(state.promotions, { key })
  )
  const rewards = R.pathOr([], ['campaign', 'rewards'], promotion)
  const promotionStartDate = R.pathOr('', ['activeFrom'], promotion)
  const promotionEndDate = R.pathOr('', ['activeTo'], promotion)

  const translate = Herz.I18n.useTranslate(
    () => [
      `promotions.${key}.terms-conditions`,
      `promotions.${key}.title`,
      'promotions.promotion.start-date',
      'promotions.promotion.end-date',
      `promotions.${key}.terms-conditions`,
    ],
    [key]
  )

  if (!translate(`promotions.${key}.terms-conditions`)) {
    return <NotFound />
  }

  return (
    <Theming.Alternative>
      <Common.Box flexDirection="column" display="flex" flexGrow="1">
        <Common.Space p={2}>
          <Heading level={2} color="page-nav-heading">
            <HtmlContent
              html={{
                __html: translate(
                  `promotions.${key}.title`,
                  R.mergeRight(
                    Promotions.getPromotionMinMax(rewards),
                    Promotions.getPromotionTranslationVariables(rewards)
                  )
                ),
              }}
            />
          </Heading>
        </Common.Space>
        <Common.Box
          display="flex"
          backgroundColor="g-bg"
          p={{ lg: 4 }}
          justifyContent="center"
          alignItems="flex-start"
          fontSize={2}
          flexGrow="1"
        >
          <Card p={[2, 4]} width="100%" maxWidth={{ lg: '1000px' }}>
            <Common.Box pb={1}>
              {promotionStartDate && (
                <HtmlContent
                  html={{
                    __html: translate('promotions.promotion.start-date', {
                      startDateAndTime: getPromotionDate(
                        promotionStartDate,
                        locale
                      ),
                    }),
                  }}
                />
              )}
              {promotionEndDate && (
                <HtmlContent
                  html={{
                    __html: translate('promotions.promotion.end-date', {
                      endDateAndTime: getPromotionDate(
                        promotionEndDate,
                        locale
                      ),
                    }),
                  }}
                />
              )}
            </Common.Box>
            <HtmlContent
              html={{
                __html: translate(
                  `promotions.${key}.terms-conditions`,
                  Promotions.getPromotionTranslationVariables(rewards)
                ),
              }}
            />
          </Card>
        </Common.Box>
      </Common.Box>
    </Theming.Alternative>
  )
}

// for @loadable/components
export default PromotionTermsAndConditionsPage
